export enum ExperimentMode {
  'BatchCulture' = 1,
  'Turbidostat' = 2,
  'Chemostat' = 3,
  'PHControl' = 4,
  'PHControlDouble' = 5,
  'PHControlChemostat' = 6,
  'Morbidostat' = 7,
}

export const ExperimentModeDisplay: Record<ExperimentMode, string> = {
  [ExperimentMode.BatchCulture]: 'Batch Culture',
  [ExperimentMode.Turbidostat]: 'Turbidostat',
  [ExperimentMode.Chemostat]: 'Chemostat',
  [ExperimentMode.PHControl]: 'pH Control',
  [ExperimentMode.PHControlDouble]: 'BETA: pH 2xControl',
  [ExperimentMode.PHControlChemostat]: 'BETA: pH + Chemostat',
  [ExperimentMode.Morbidostat]: 'BETA: Morbidostat',
};
